import * as React from 'react';
import clsx from 'clsx';
import BackgroundBubbles from '@/components/common/BackgroundBubbles';
import { useEchoStore } from '@/context/EchoContext';
import { SmartEchoCard } from '@/features/home/components/SmartEchoCard';
import noEchoImage from '@/assets/images/echo/no_echo.webp';
// Assets
import waveElement from '@/assets/images/webp/wave_element.webp';
import womanPhoneimg from '@/assets/images/elements/woman_phone.webp';
import bottomBlur from '@/assets/images/elements/bottom_blur.svg';
import pinkBlur from '@/assets/images/elements/pink_blur.svg';

export const AuthBrandingCard: React.FC = () => {
  const { publicEchoesList } = useEchoStore();

  const displayEchoes = React.useMemo(() => publicEchoesList.slice(0, 8), [publicEchoesList]);

  return (
    <div
      className={clsx(
        'relative size-full bg-brand-970',
        'overflow-hidden',
        'rounded-[35px]',
        '4xl:rounded-[2.1875rem]'
      )}
    >
      {/* Independent Background Layer (z-0) */}
      <div className='pointer-events-none absolute inset-0 z-0'>
        {/* 1. Radial Gradient Base */}
        <div className='absolute inset-0 bg-[radial-gradient(circle_at_center,_theme(colors.brand.700)_0%,_transparent_70%)] opacity-30' />

        {/* 2. Full Size Wave Element (PNG) */}
        <img
          src={waveElement}
          alt=''
          className='absolute inset-0 size-full object-cover opacity-100'
        />

        <div className='absolute left-1/2 top-[35%] flex size-full -translate-x-1/2 -translate-y-1/2 items-center justify-center pt-[5%]'>
          {/* Pink Blur: Centered Behind */}
          <img
            src={pinkBlur}
            alt=''
            className='absolute left-1/2 top-1/2 z-0 h-4/5 w-auto -translate-x-1/2 -translate-y-1/2 scale-125 object-contain opacity-80 mix-blend-screen'
          />

          {/* Woman Image */}
          <img
            src={womanPhoneimg}
            alt=''
            // Reduced height from 85% to 75%
            className='relative z-10 h-3/4 w-auto object-contain'
          />

          {/* Bottom Blur: In Front at Bottom */}
          <img
            src={bottomBlur}
            alt=''
            className='absolute bottom-0 left-1/2 z-20 w-full min-w-[120%] -translate-x-1/2 translate-y-[10%] object-cover'
          />
        </div>

        {/* 4. Bubbles Overlay */}
        <BackgroundBubbles count={40} />
      </div>

      <div className='absolute inset-x-0 bottom-0 z-10 px-[4.3%] pb-[11.5%]'>
        <div className='grid grid-cols-4 place-items-center gap-x-[2.4%] gap-y-[2%]'>
          {displayEchoes.map((echo) => (
            <SmartEchoCard
              key={echo.id}
              echo={echo}
              imageSrc={echo.imageUrl || noEchoImage}
              borderColor='#BFB0F8'
              className='!aspect-[153/174] !h-auto !w-full !min-w-0 rounded-20 border-3 shadow-lg transition-transform'
              imageContainerClassName='!h-[98%]'
              panelClassName={clsx(
                '!h-[3.1625rem]',
                '!flex-col !justify-center !pt-0',
                '!gap-2',
                '[&>p]:!text-[10px] [&>p]:!mb-0 [&>p]:!leading-none'
              )}
              titleClassName='!text-[12px] !mb-0 !leading-none'
              hideBadges={true}
            />
          ))}
        </div>
      </div>

      {/* Footer Text with Gradient Background (z-20) */}
      <div className='absolute bottom-0 left-0 z-20 w-full bg-gradient-to-t from-brand-970 via-brand-970/90 to-transparent p-[4.3%] pt-[10%]'>
        <p className='font-sans text-16 font-medium leading-21 text-white'>
          Meet up to <span className='text-[22px]'>200+</span> echoes you can chat with.
        </p>
      </div>
    </div>
  );
};
